angular.module('shared').directive('truncatedMessage', ["$timeout", function($timeout) {
  return {
    restrict: 'E',
    scope: {
      data: '=',
      maxHeight: '@'
    },
    template: require('templates/components/contacts/comms/truncated_message.html.slim'),
    link: {
      post: function($scope, element) {
        var fullContent, imageContent, trimmedContent, truncateContent;
        trimmedContent = function() {
          return angular.element(element[0].querySelector('.ta-trimmed-content'));
        };
        fullContent = function() {
          return angular.element(element[0].querySelector('.ta-full-content'));
        };
        imageContent = function() {
          return angular.element(element[0].querySelectorAll('img'));
        };
        $scope.isEmail = function() {
          return $scope.data.channel === 'email';
        };
        $scope.shouldBeTruncated = function() {
          return parseInt(fullContent().css('height')) > parseInt($scope.maxHeight);
        };
        truncateContent = function() {
          return $timeout(function() {
            if ($scope.shouldBeTruncated()) {
              return trimmedContent().css({
                'max-height': $scope.maxHeight
              });
            }
          });
        };
        $timeout(function() {
          imageContent().on('load', function() {
            return truncateContent();
          });
          return truncateContent();
        });
        return $scope.toggle = function() {
          var height;
          height = $scope.expanded ? $scope.maxHeight : 'none';
          trimmedContent().css({
            'max-height': height
          });
          return $scope.expanded = !$scope.expanded;
        };
      }
    }
  };
}]);
